var _helper = require('./helper');

/**
 * Form module to handle form events
 */
module.exports = {
		
	/**
	 * Attach submit event to handle the form errors
	 * Not in use at the moment
	 */
	init: function(params) {
		var self = this, $form = params.$form;
		self.initPlaceholder($form);
	},
	
	/**
	 * set placeholders to text/password fields
	 */
	initPlaceholder: function($form) {

		var textSelector = 'input[type=text]' + ($.isFunction($.fn.placeholder) ? ':not([id^=shadow])' : '');
		var passwordSelector = 'input[type=password]';

		var self = this, 
			$textFields = $(textSelector, $form), 
			$passwordFields = $(passwordSelector, $form),
			$allFields = $(textSelector + ',' + passwordSelector, $form);

		// Put labels into placeholders for all browsers
		$allFields.each(function(index, field) {
			var label = _helper.getLabel(field);
			$(field).attr('placeholder', label);
		});

		// only for IE8/9. Refer to: js.jsp
		if($.isFunction($.fn.placeholder)) {
			$textFields.placeholder();
			self.initPasswordFielsPlaceholder($passwordFields);
		}
	},
	
	/**
	 * Initialize the placeholders of the password fields
	 */
	initPasswordFielsPlaceholder: function($passwordFields) {
		var self = this;

		$passwordFields.each(function(index, field) {
			var $field = $(field);
			var $ph = $field.siblings('.password-placeholder[for=' + field.id.replace('shadow-', '') + ']');

			$field.off('focus blur').on('focus blur', function(e) {
				var hide = e.type === 'focus' || $field.val().length > 0;
				$ph.toggleClass('hidden', hide);
				self.positionPlaceholder($field, $ph, hide);
			});

			// hook events
			$ph.off('click').on('click', function(e) {
				$field.trigger('focus');
			});

			var hide = $field.val().length > 0;
			// hide placeholder if password is not empty
			$ph.toggleClass('hidden', hide);
			// Calculate the position of the placeholder
			self.positionPlaceholder($field, $ph, hide);
		});
	},

	/**
	 * Calculate the position of the placeholder
	 */
	positionPlaceholder: function($field, $ph, hide) {
		if(!hide) {
			var left = $field.position().left;
			var offsetTop = $field.parent().height()/2 - $ph.height()/2;
			$ph.css({top: offsetTop, left: left+10});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/form.js
// module id = 32
// module chunks = 4 7